<div class="help-contact-form-success">
    <eb-h2>{{ 'help.success.title' | transloco }}</eb-h2>
    <eb-icon
        class="help-contact-form-success__icon"
        icon="ui/action/symbols/check-broken"
        width="64"
    />
    <eb-label size="lg">
        {{ 'help.success.message_line1' | transloco }}
    </eb-label>
    <eb-label size="lg">
        {{ 'help.success.message_line2' | transloco }}
    </eb-label>
</div>
